import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'asax-header',
  template: `
    <nav class="navbar navbar-expand navbar-light bg-primary" style="height: 40px;">
      <div class="container-fluid ps-1 pe-1">
        <asax-header-search-container></asax-header-search-container>
        <asax-header-filters-container style="width: 60%;"></asax-header-filters-container>

        <asax-header-download-container></asax-header-download-container>
        <asax-header-share-container></asax-header-share-container>
        <asax-header-help-container></asax-header-help-container>
      </div>
    </nav>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsaxHeaderComponent {
}
